import { Stack } from '@mui/material'
import { useTexts } from '../hooks/useTexts'
import { form } from './formState'

export function Name() {
  const texts = useTexts()

  return (
    <Stack mt={3}>
      <form.TextField
        label={texts.form.name.label}
        validateOn="blur change"
        name="name"
        testId="name"
      />
    </Stack>
  )
}
